import config from "./env-config.json";

export const environment = {
  ...config
};
